export const TASKS_LIST_PATH = "/tasks";

export const TASKS_TAB_PARAM = "tab";

const ALL = "all";
const TODAY = "today";
const APPOINTED_BY_ME = "appointed by me";
const MY_TEAM = "my team";

export const TABS = {
  ALL,
  TODAY,
  APPOINTED_BY_ME,
  MY_TEAM,
};
